var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRsfDe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 571.09 144.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e40046;}.cls-2{fill:#fff;}.cls-3{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M230.54,82.08h-2.85V97H221V60.23h10.15c7.32,0,9.44,2.12,9.44,8.62v5c0,3.79-1.17,6.09-3.66,7.27L241.1,97h-6.91Zm-2.85-15.67V76.52h3.43c2,0,2.71-.63,2.71-3.34V69.75c0-2.71-.67-3.34-2.71-3.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M262.23,97H245.66V60.23h16.57v6.41h-9.84v8.12h9.39v6.1h-9.39v9.75h9.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M273.72,85.19V97H267V60.23h10.06c7.32,0,9.76,2.61,9.76,9.07v7c0,6.27-2.44,8.89-9.76,8.89Zm0-18.78v13H277c2.12,0,3.11-.81,3.11-4.11V70.47c0-3.25-1-4.06-3.11-4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M301.85,97.25C294.17,97.25,291,93.54,291,86V71.24C291,63.7,294.17,60,301.85,60s10.88,3.7,10.88,11.24V86C312.73,93.54,309.52,97.25,301.85,97.25Zm0-31c-2.84,0-4.15,1.22-4.15,5.78V85.28c0,4.52,1.31,5.69,4.15,5.69S306,89.8,306,85.28V72c0-4.55-1.31-5.77-4.15-5.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M327.13,82.08h-2.84V97h-6.73V60.23h10.16c7.32,0,9.44,2.12,9.44,8.62v5c0,3.79-1.18,6.09-3.66,7.27L337.7,97h-6.91Zm-2.84-15.67V76.52h3.43c2,0,2.71-.63,2.71-3.34V69.75c0-2.71-.68-3.34-2.71-3.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M353.41,67V97h-6.73V67H341V60.23h18.19V67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M380.44,97H363.87V60.23h16.57v6.41h-9.85v8.12H380v6.1h-9.39v9.75h9.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M394.77,82.08h-2.84V97H385.2V60.23h10.16c7.31,0,9.43,2.12,9.43,8.62v5c0,3.79-1.17,6.09-3.65,7.27L405.34,97h-6.91Zm-2.84-15.67V76.52h3.43c2,0,2.71-.63,2.71-3.34V69.75c0-2.71-.68-3.34-2.71-3.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M231.71,144.32c-7.67,0-10.88-3.7-10.88-11.24V118.31c0-7.54,3.21-11.24,10.88-11.24s10.88,3.7,10.88,11.24v14.77C242.59,140.62,239.39,144.32,231.71,144.32Zm0-31c-2.84,0-4.15,1.22-4.15,5.78v13.27c0,4.52,1.31,5.69,4.15,5.69s4.16-1.17,4.16-5.69V119.08c0-4.56-1.31-5.78-4.16-5.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M261.29,128.11h-7.13v16h-6.73V107.3h6.73v14h7.13v-14h6.77v36.79h-6.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M279.62,123.55v20.54h-6.19V107.3h6.64l7.77,20.27V107.3H294v36.79h-6.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M316,144.09H299.44V107.3H316v6.41h-9.84v8.13h9.39v6.09h-9.39v9.75H316Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M332.58,133V118.27c0-7.86,3.43-11.2,10.88-11.2,7.63,0,10.83,3.12,10.83,10.07v4.6h-6.72v-4c-.05-3.3-1.31-4.38-4.16-4.38s-4.1,1.22-4.1,5.69v13.27c0,4.56,1.3,5.78,4.19,5.78,2.53,0,4-.72,4-4.43v-3.74h-4.2v-5.29h11V144.1h-2.4l-1.31-5.1c-.86,3.38-3.2,5.37-7.85,5.37C335.47,144.32,332.58,140.8,332.58,133Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M369.24,129.15h-2.85v14.94h-6.72V107.3h10.16c7.31,0,9.43,2.12,9.43,8.62v5c0,3.79-1.17,6.1-3.66,7.27l4.2,15.89h-6.9Zm-2.85-15.67V123.6h3.44c2,0,2.7-.64,2.7-3.34v-3.44c0-2.7-.67-3.34-2.7-3.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M400.93,144.09H384.36V107.3h16.57v6.41h-9.84v8.13h9.39v6.09h-9.39v9.75h9.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M411.88,123.55v20.54H405.7V107.3h6.63l7.77,20.27V107.3h6.18v36.79h-6.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M430.62,139.76l11.87-26H431.25V107.3h19.41v4.33l-11.42,26.05h11.42v6.41h-20Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M471.57,144.09H455V107.3h16.57v6.41h-9.84v8.13h9.39v6.09h-9.39v9.75h9.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M482.52,123.55v20.54h-6.19V107.3H483l7.76,20.27V107.3H497v36.79h-6.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M209.2,26.22V0H95.9V.25c11.46,0,24.76.33,35.35,4.61a28,28,0,0,1,16,17.26,38.06,38.06,0,0,1,1.86,11.45V43.78H119.52V33.36c0-3.05.31-9-5-9-4.78,0-4.87,4.88-4.87,7.87V43c0,7.13,4.27,10.69,6.77,12.54,4.37,3.22,14.06,8.89,17.73,11.67a35.45,35.45,0,0,1,14.29,24.68,69.93,69.93,0,0,1,.55,7.92c.08,4.76.09,9.53,0,14.29a34,34,0,0,1-3.75,15.67c-5.79,10.74-13.75,14.12-25.91,14.12v.25h60V86h28.94V60.23h-29v-34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M119.33,101.56c0-5.24-2.42-9.29-6.48-12.35-2.54-1.93-14.94-9.72-18.26-12.14A35.76,35.76,0,0,1,80.35,48.29v-14c0-14.47-2.61-21.5-7.27-26.12C67.5,2.63,58.21,0,43.58,0H0V144.09H30.2V85.85h6.89a5.36,5.36,0,0,1,5.2,4.08l13.25,54.16H110v-.25c-9.25,0-14.1-1.19-20.74-7.49s-9-14.35-9-23.57V101.61H110c0,4.21.07,8,.07,12.21,0,3.41.44,7.19,4.77,7.19,3.88,0,4.52-3.94,4.52-7.85v-11.6M50.15,51.19c0,10.55-2.64,13-10.56,13H30.2V24.79h9.39c7.92,0,10.56,2.47,10.56,13Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 571.09,
    height: 144.37
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRsfDe);
export default __webpack_public_path__ + "static/media/RSF_de.24cff565f79900e9ae3166d48ff2ae3f.svg";
export { ForwardRef as ReactComponent };